import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { borderColor, brandPrimaryHover, midGray, white } from '../../../../../../../web/styles/colors';

// --custom-* vars come from the page theme the API injects on public survey pages; the fallbacks are
// the components-v2 secondary variant's own colors, so accounts without custom buttons are
// unchanged. The theme carries one button color and no secondary one, so the outline follows the
// primary button's fill, and hover fills with it rather than tinting it: CSS can't express "tint
// when the var is set, keep the pale blue otherwise" in one declaration.
const brandFill = `var(--custom-primary-button-bg, ${THEME.colors.primary.main})`;
const brandText = `var(--custom-primary-button-text, ${THEME.colors.primary.main})`;

export const styleSheet = StyleSheet.create({
	dropdownMenu: {
		background: white,
		border: `1px solid ${borderColor}`,
		boxShadow: '0 0 6px 0 rgba(184,184,184,0.30)',
		marginTop: 21,
		maxHeight: 300,
		overflowY: 'auto',
		minWidth: '100%',
	},
	dropdownButton: {
		width: '100%',
		color: brandFill,
		border: `1px solid ${brandFill}`,
		':active': {
			background: 'var(--custom-primary-button-bg, #E6ECF3)',
			color: brandText,
		},
		':hover': {
			background: 'var(--custom-primary-button-bg, #EAF7FA)',
			border: `1px solid var(--custom-primary-button-bg, ${brandPrimaryHover})`,
			color: brandText,
		},
	},
	menuItem: {
		':hover': {
			background: midGray,
		},
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 'normal',
		overflow: 'hidden',
		padding: 16,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});
